<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"margin-bottom: 80px;\npadding-top:80px;"' class="container " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"height: 1rem;\nwidth:99%;\n"' class="text-center container-fluid my-5" >
                <template #default>   <m-h2 v-bind='{...{},...{}}' :style='"border-bottom:2px solid black"' class="mb-5 text-primary d-inline-block pb-3" >
                <template #default>U.TABMEHR TANDIS CO
   </template>
                </m-h2></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>   <m-h2 v-bind='{...{},...{}}' :style='"border-bottom:2px solid black;\nfont-size: 20px;"' class="mb-5 text-primary d-inline-block pb-3" >
                <template #default>لتلقي النصائح والتواصل، يرجى ملء النموذج أدناه.   </template>
                </m-h2></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="justify-content-center row mx-auto" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 mx-auto" >
                <template #default>   <m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-4","formId":2,"redirectToDashboard":false,"redirectDirectLink":""},...{}}' :style='""' class="" ></m-form-single-1></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center my-4" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 text-center" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='"font-size: 16px;"' class="mb-4" >
                <template #default>عنوان: إيران . محافظة خوزستان، مدينة دزفول، شارع الدكتور شريعتي   </template>
                </m-h3><m-a v-bind='{...{"href":"","target":"_self"},...{}}' :style='""' class="d-block" >
                <template #default>adel.tandis@gmail.com   </template>
                </m-a><m-a v-bind='{...{"href":"","target":"_self"},...{}}' :style='""' class="d-block" >
                <template #default>info @utmtco.com   </template>
                </m-a><m-div v-bind='{...{},...{}}' :style='""' class="font-weight-bolder mt-3" >
                <template #default>   <m-a v-bind='{...{"href":"tel:+986142544241","target":"_self"},...{}}' :style='" direction: ltr;\nfont-family:arial"' class="d-block text-dark my-2" >
                <template #default>+986142544241   </template>
                </m-a><m-a v-bind='{...{"href":"tel:+989190102898","target":"_self"},...{}}' :style='" direction: ltr;\nfont-family:arial"' class="d-block text-dark my-2" >
                <template #default>+989190102898   </template>
                </m-a><m-a v-bind='{...{"href":"tel:+989166469640","target":"_self"},...{}}' :style='" direction: ltr;\nfont-family:arial"' class="d-block text-dark my-2" >
                <template #default>+989166469640   </template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH2 from '@moeinmdn/miw-alpha-components/src/package/Tags/H2'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH2,mFormSingle1,mH3,mA },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
